import DirectorClient from "@/apis/directorClient";
import User from "@/apis/user";

import {
  deleteDirectorTokenInLocalStorage,
  setTokenInLocalStorage,
  setDirectorInfoLocalStorage
} from "@/utils/oauth";

import { deleteAccessTokenInHeader } from "@/apis/common_api";

import store from "@/store";
import router from "@/router";
import { requestToken } from "@/apis/auth_api";

const director = new DirectorClient();
const user = new User(director);

const state = {
  accessToken: localStorage.getItem("access_token"),
  type: "director",
  director: {
    id: localStorage.getItem("directorId"),
    userId: localStorage.getItem("directorUserId"),
    name: localStorage.getItem("directorName"),
    phone: localStorage.getItem("directorPhone"),
    Corps: localStorage.getItem("directorCorps"),
    Account: localStorage.getItem("directorAccount"),
    SecurityNumber: localStorage.getItem("directorSecurityNumber"),
    marketingAgree: localStorage.getItem("directorMarketingAgree")
  },
  isDirectorAuthenticated:
    localStorage.getItem("access_type") === "director" &&
    localStorage.getItem("access_token")
};

const resetToken = state => {
  deleteDirectorTokenInLocalStorage();
  deleteAccessTokenInHeader();
  state.accessToken = null;
};

const getters = {
  isDirectorAuthenticated(state) {
    return state.isDirectorAuthenticated;

    // return state.director.id !== null ? true : false;
  },
  directorInfo(state) {
    return state.director;
  }
};

const mutations = {
  SET_DIRECTOR_ACCESS_TOKEN(state, data) {
    state.accessToken = data;
    state.isDirectorAuthenticated = true;
  },
  LOGIN(state) {
    // state.accessToken = localStorage.getItem("access_token");
    state.isDirectorAuthenticated = true;
    router.push("/");
    store.dispatch("REQUEST_OBITUARY_ALL_LIST");
  },
  LOGOUT_DIRECTOR(state) {
    resetToken(state);
    state.isDirectorAuthenticated = false;
    state.director = null;
    store.commit("REQUEST_OBITUARY_ALL_LIST_INIT");
  },

  // new
  DIRECTOR_DETAIL(state, data) {
    state.director = data.resultDirector;
  },

  LOGOUT_WITH_TOKEN_INVALIDE(state) {
    resetToken(state);
    if (router.currentRoute.name != "boards") {
      router.push("/");
    }
  }
};

const actions = {
  async REQUEST_LOGOUT_DIRECTOR({ commit }) {
    try {
      commit("START_LOADING");
      const data = await user.logout();
      commit("LOGOUT_DIRECTOR");
      router.replace("/director/loginDo");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_DIRECTOR_JOIN({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.join(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      router.push("/director/loginDo");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_DIRECTOR_LOGIN({ commit }, parameter) {
    try {
      commit("START_LOADING");
      // 엑세스 토큰 발급

      const token = await requestToken(parameter);

      if (token.data?.result !== "success") {
        alert(token.data.message);

        return;
      }
      await setTokenInLocalStorage({ ...token.data, type: parameter.type });

      await user.setToken(token.data.access_token);

      const data = await user.login(parameter.user);

      if (data?.result !== "success") {
        alert(data.message);

        commit("LOGOUT_DIRECTOR");
        return;
      }

      await setDirectorInfoLocalStorage(data.resultDirector);
      await commit("DIRECTOR_DETAIL", data);

      if (data.resultDirector.password === "0000") {
        const routePath = "/passwordSetting";
        router.push(routePath);
        return;
      }

      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // nes
  async DIRECTOR_DETAIL({ commit, state }) {
    try {
      commit("START_LOADING");
      const data = await user.getDetail();
      // setMemberInfoLocalStorage(getMember.data.resultMember);

      if (data?.result !== "success") {
        alert(data.message);
        router.push("/login");
        return;
      }

      await setDirectorInfoLocalStorage(data.resultDirector);

      commit("DIRECTOR_DETAIL", data);
    } catch (error) {
      console.error(error);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_DIRECTOR_CORP_ADD({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const data = await user.addCorp(parameter);

      if (data?.result !== "success") {
        alert(data?.message);
      }

      commit("DIRECTOR_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // new - 회원탈퇴
  async REQUEST_DELETE_DIRECTOR({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.delete(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      alert("탈퇴가 완료되었습니다.");
      commit("LOGOUT");
      router.push("/login");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_CHANGE_MARKET_AGREE_DIRECTOR({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.changeMarketingAgree(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("DIRECTOR_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_CHANGE_APPLY_CORP({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.applyCorp(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("DIRECTOR_DETAIL", data);
    } catch (e) {
      console.error(e);

      if (e === "refresh") {
        return;
      }

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_DIRECTOR_ADD_ACCOUNT({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.addAccount(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("DIRECTOR_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_DIRECTOR_ADD_SECURITY_NUMBER({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.addSecurityNumber(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("DIRECTOR_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
